import React from 'react';


const svgIcon = props => (
                <a href={props.url} >
                    <img 
                        href={props.url}
                        src={props.icon}
                        alt="not found" />
                </a>
)

export default svgIcon;


// WEBPACK FOOTER //
// ./src/components/UI/SvgIcon/SvgIcon.js